// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../ui/styles/tavern-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Lato:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Tavern Theme Design System */

/* Import Google Fonts for Tavern Theme */

:root {
  /* Legacy Telegram theme mappings - map to tavern colors */
  --app-bg: var(--color-wood-900);
  --app-surface: var(--color-parchment-100);
  --app-text: var(--color-text-primary);
  --app-hint: var(--color-text-tertiary);
  --app-link: var(--color-fire-600);
  --app-button: var(--color-fire-600);
  --app-button-text: var(--color-parchment-100);
  --app-danger: var(--color-danger-500);
  --app-separator: var(--color-wood-700);
  --app-success: var(--color-success-500);
  --app-warning: var(--color-warning-500);
}

* {
  box-sizing: border-box;
}

html,
body {
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  /* The shell scrolls inside .ttbShellMain; keep the WebView from rubber-banding the whole page */
  overscroll-behavior: none;
}

body {
  margin: 0;
  font-family: var(--font-body);
  color: var(--color-text-primary-light);
  background-color: #2d1f10;

  background-image:
    /* Vignette — darker edges for depth */
    radial-gradient(
      ellipse at 50% 50%,
      transparent 40%,
      rgba(10, 6, 2, 0.35) 100%
    ),
    /* Knot 1 — dark oval spot */
    radial-gradient(
      ellipse 18px 28px at 15% 25%,
      rgba(30, 18, 8, 0.6) 0%,
      rgba(45, 28, 12, 0.3) 40%,
      transparent 70%
    ),
    /* Knot 2 */
    radial-gradient(
      ellipse 14px 22px at 78% 62%,
      rgba(28, 16, 6, 0.5) 0%,
      rgba(42, 25, 10, 0.25) 45%,
      transparent 70%
    ),
    /* Knot 3 */
    radial-gradient(
      ellipse 12px 18px at 42% 85%,
      rgba(32, 20, 8, 0.45) 0%,
      rgba(48, 30, 14, 0.2) 50%,
      transparent 70%
    ),
    /* Grain — fine horizontal wood fibers */
    repeating-linear-gradient(
      180deg,
      transparent 0px,
      transparent 1px,
      rgba(90, 67, 40, 0.08) 1px,
      rgba(90, 67, 40, 0.08) 2px,
      transparent 2px,
      transparent 4px
    ),
    /* Grain variation — slightly thicker fibers at intervals */
    repeating-linear-gradient(
      179deg,
      transparent 0px,
      transparent 11px,
      rgba(74, 53, 32, 0.12) 11px,
      rgba(80, 58, 35, 0.14) 13px,
      transparent 13px,
      transparent 29px
    ),
    /* Grain wave — angled lines for organic feel */
    repeating-linear-gradient(
      182deg,
      transparent 0px,
      transparent 19px,
      rgba(65, 45, 25, 0.10) 19px,
      rgba(70, 48, 28, 0.12) 20px,
      transparent 20px,
      transparent 47px
    ),
    /* Wide plank bands — subtle tonal shifts */
    repeating-linear-gradient(
      180deg,
      rgba(74, 53, 32, 0.15) 0px,
      rgba(58, 40, 22, 0.20) 120px,
      rgba(74, 53, 32, 0.10) 240px,
      rgba(65, 45, 25, 0.18) 360px
    ),
    /* Vertical grain variation — faint, for realism */
    repeating-linear-gradient(
      92deg,
      transparent 0px,
      rgba(80, 58, 35, 0.06) 1px,
      transparent 3px,
      transparent 60px,
      rgba(70, 48, 28, 0.04) 61px,
      transparent 63px
    ),
    /* Base warm gradient */
    linear-gradient(
      180deg,
      #5a4328 0%,
      #4d3820 20%,
      #44301a 45%,
      #3a2714 70%,
      #2d1f10 100%
    );

  background-attachment: fixed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: var(--color-fire-600);
  text-decoration: none;
  transition: all var(--transition-fast) var(--transition-timing);
}

a:hover {
  color: var(--color-fire-500);
  text-decoration: underline;
}

button {
  font: inherit;
  cursor: pointer;
  transition: all var(--transition-fast) var(--transition-timing);
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Headings */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-heading);
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.02em;
  margin: 0;
  color: var(--color-fire-600);
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

/* ---------- Layout utilities ---------- */

.ttbPage {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 16px;
  min-height: 100%;
}

@media (min-width: 768px) {
  .ttbPage {
    padding: 24px;
  }
}

.ttbPageTitle {
  margin: 0;
  font-size: 20px;
  font-weight: 900;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.ttbRowBetween {
  justify-content: space-between;
}

.ttbStackSm {
  display: grid;
  gap: 8px;
}

.ttbStackMd {
  display: grid;
}
.ttbMb12 {
  margin-bottom: 12px;
}

.ttbDayTitle {
  font-size: 16px;
  font-weight: 800;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* ---------- Icon/compact controls ---------- */

.ttbIconButton {
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
  font-size: 16px;
  font-weight: 900;
}

.ttbButtonOutlineSm {
  height: 36px;
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
  font-weight: 800;
  white-space: nowrap;
}

.ttbButtonOutlineSm:disabled {
  opacity: 0.5;
}

.ttbButtonOutlineWide {
  width: 100%;
  border-radius: 12px;
  font-weight: 900;
}

.ttbAvatarSm {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  object-fit: cover;
}

/* ---------- Event card ---------- */

/* Event card slots container */
.ttbEventSlots {
  display: grid;
  gap: var(--space-2);
  margin-top: var(--space-2);
}

.ttbShell {
  min-height: 100dvh;
  height: 100dvh;
  display: grid;
}

.ttbShellWithNav {
  grid-template-rows: 1fr auto;
}

.ttbShellNoNav {
  grid-template-rows: 1fr;
}

.ttbShellMain {
  overflow: auto;
  min-height: 0;
  /* At the end of the list do not hand the gesture to the page (it would drag the bottom nav) */
  overscroll-behavior-y: contain;
}

/* ---------- Bottom navigation ---------- */

.ttbBottomNav {
  border-top: 2px solid var(--color-wood-700);
  padding-top: var(--space-2);
  padding-bottom: calc(var(--space-2) + var(--safe-bottom));
  background: var(--color-wood-900);
  box-shadow: var(--shadow-nav);
}

.ttbBottomNavDisabled {
  opacity: 0.6;
}

.ttbBottomNavGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: var(--space-1);
  padding: 0 var(--space-2);
}

.ttbBottomNavLink {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-1);
  height: 56px;
  border-radius: var(--radius-md);
  color: var(--color-text-secondary-light);
  text-decoration: none;
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
  transition: all var(--transition-fast) var(--transition-timing);
}

.ttbBottomNavLink:hover {
  background: var(--color-wood-800);
}

.ttbBottomNavLinkActive {
  color: var(--color-fire-600);
  background: var(--color-wood-800);
}

.ttbBottomNavLinkDisabled {
  pointer-events: none;
  opacity: 0.4;
}

.ttbBottomNavIcon {
  font-size: 20px;
  line-height: 1;
}

.ttbBottomNavLabel {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ttbBottomNavBadge {
  position: absolute;
  top: -6px;
  right: -14px;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--app-danger);
  color: var(--app-button-text);
  font-size: 11px;
  font-weight: 900;
  line-height: 18px;
  text-align: center;
}

/* Цветовые варианты бейджей */
.ttbBottomNavBadge--success {
  background: var(--color-success-500);
  color: #fff;
}

.ttbBottomNavBadge--warning {
  background: var(--color-warning-500);
  color: #1a1a1a;
}

/* Группа из двух бейджей */
.ttbBottomNavBadgeGroup {
    position: static;
  display: flex;
  position: absolute;
  justify-content: space-between;
  top: 16px;
  right: -12px;
  display: flex;
  gap: 15px;
  /* margin: 5px; */

}

.ttbBottomNavBadgeGroup .ttbBottomNavBadge {
  position: static;
}

.ttbBottomNavBadge {  
   flex: auto;
}

.ttbButtonOutlineHeader {
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
  font-weight: 700;
}

.ttbButtonOutlineHeader:disabled {
  opacity: 0.5;
}

.ttbPageContent {
  margin-top: 16px;
}

.ttbStack {
  display: grid;
  gap: 12px;
}

.ttbStackLg {
  display: grid;
  gap: 16px;
}

.ttbRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ttbRowWrap {
  flex-wrap: wrap;
}

.ttbGrow {
  flex: 1 1 auto;
  min-width: 0;
}

.ttbCenterText {
  text-align: center;
}

.ttbHint {
  color: var(--app-hint);
}

.ttbDivider {
  height: 1px;
  background: var(--app-separator);
}

/* ---------- Desktop shell: sidebar instead of bottom nav (>=1024px) ---------- */

@media (min-width: 1024px) {
  .ttbShellWithNav {
    grid-template-columns: var(--sidebar-width) minmax(0, 1fr);
    grid-template-rows: 1fr;
  }

  .ttbShellWithNav > .ttbShellMain {
    grid-column: 2;
    grid-row: 1;
  }

  .ttbShellWithNav > .ttbBottomNav {
    grid-column: 1;
    grid-row: 1;
    border-top: none;
    border-right: 2px solid var(--color-wood-700);
    padding: var(--space-5) var(--space-3);
    box-shadow: var(--shadow-nav);
    overflow-y: auto;
  }

  .ttbBottomNavGrid {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    padding: 0;
  }

  .ttbBottomNavLink {
    flex-direction: row;
    justify-content: flex-start;
    gap: var(--space-3);
    height: 48px;
    padding: 0 var(--space-4);
    font-size: var(--font-size-body);
  }

  .ttbBottomNavIcon {
    font-size: 22px;
  }

  .ttbPage {
    max-width: var(--content-max);
    padding: var(--space-6) var(--space-7);
  }
}

/* ---------- Buttons ---------- */

.ttbButton {
  font: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border: none;
  padding: 0;
  background: transparent;
}

.ttbButton:disabled {
  cursor: not-allowed;
}

.ttbButtonPrimary {
  width: 100%;
  height: 52px;
  border-radius: var(--radius-md);
  border: 2px solid var(--color-wood-700);
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  font-family: var(--font-body);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-body);
  padding: var(--space-3) var(--space-5);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-button);
  cursor: pointer;
  transition: all var(--transition-fast) var(--transition-timing);
}

.ttbButtonPrimary:hover:not(:disabled) {
  background: var(--color-fire-500);
  transform: translateY(-1px);
}

.ttbButtonPrimary:active:not(:disabled) {
  background: var(--color-fire-700);
  transform: translateY(0);
}

.ttbButtonPrimary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ttbButtonOutline {
  height: 44px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
  font-weight: 700;
}

.ttbButtonOutline:disabled {
  opacity: 0.5;
}

.ttbButtonOutlineCompact {
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  font-weight: 800;
}

/* ---------- UI primitives ---------- */

.ttbCard {
  background: var(--color-parchment-100);
  border-radius: var(--radius-xl);
  padding: var(--space-4);
  border: 3px solid var(--color-wood-700);
  box-shadow: var(--shadow-card);
  transition: all var(--transition-normal) var(--transition-timing);
}

.ttbCard:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-card-hover);
}

.ttbCardScrollable {
  max-height: 240px;
  overflow: auto;
}

/* ---------- Bottom sheet ---------- */

.ttbBottomSheetRoot {
  position: fixed;
  inset: 0;
  display: grid;
  grid-template-rows: 1fr auto;
  z-index: 50;
}

.ttbBottomSheetOverlay {
  background: rgba(0, 0, 0, 0.35);
}

.ttbBottomSheetPanel {
  background: var(--app-surface);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-top: 1px solid var(--app-separator);
  padding: 16px;
  padding-bottom: calc(16px + var(--safe-bottom));
  max-width: 640px;
  margin: 0 auto;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .ttbBottomSheetRoot {
    grid-template-rows: 1fr;
    place-items: center;
  }

  .ttbBottomSheetOverlay,
  .ttbBottomSheetPanel {
    grid-area: 1 / 1;
  }

  .ttbBottomSheetOverlay {
    width: 100%;
    height: 100%;
  }

  .ttbBottomSheetPanel {
    border-radius: 16px;
    border: 1px solid var(--app-separator);
    padding-bottom: 16px;
    max-width: 560px;
    max-height: 80vh;
    position: relative;
  }
}

.ttbBottomSheetHeader {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ttbBottomSheetTitle {
  font-size: 16px;
  font-weight: 700;
}

.ttbBottomSheetClose {
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
  font-weight: 700;
}

.ttbBottomSheetBody {
  margin-top: 12px;
}

/* ---------- Confirm sheet ---------- */

.ttbConfirmMessage {
  color: var(--app-text);
  font-size: 14px;
  line-height: 1.35;
}

.ttbConfirmActions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 16px;
}

.ttbConfirmButton {
  height: 48px;
  border-radius: 10px;
  font-weight: 700;
}

.ttbConfirmCancel {
  border: 1px solid var(--app-separator);
  background: transparent;
  color: var(--app-text);
}

.ttbConfirmConfirm {
  border: none;
  background: var(--app-button);
  color: var(--app-button-text);
}

.ttbConfirmConfirmDestructive {
  background: var(--app-danger);
}

/* ---------- Badge ---------- */

.ttbBadge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid currentColor;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

.ttbBadgeOpen {
  color: var(--app-success);
}

.ttbBadgePrivate {
  color: var(--app-hint);
}
`, "",{"version":3,"sources":["webpack://./src/pages/_base.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAGtC,yCAAyC;;AAGzC;EACE,0DAA0D;EAC1D,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,6CAA6C;EAC7C,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gGAAgG;EAChG,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,sCAAsC;EACtC,yBAAyB;;EAEzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAoFG;;EAEH,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;;;;;;EAME,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,2CAA2C;;AAE3C;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,gDAAgD;;AAEhD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8FAA8F;EAC9F,8BAA8B;AAChC;;AAEA,4CAA4C;;AAE5C;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,yDAAyD;EACzD,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,+DAA+D;AACjE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,SAAS;EACT,iBAAiB;;AAEnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;GACG,UAAU;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA,kFAAkF;;AAElF;EACE;IACE,0DAA0D;IAC1D,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,6CAA6C;IAC7C,sCAAsC;IACtC,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;AACF;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,8BAA8B;EAC9B,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gCAAgC;;AAEhC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Import Tavern Theme Design System */\n@import url('../ui/styles/tavern-theme.css');\n\n/* Import Google Fonts for Tavern Theme */\n@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Lato:wght@400;500;600;700&display=swap');\n\n:root {\n  /* Legacy Telegram theme mappings - map to tavern colors */\n  --app-bg: var(--color-wood-900);\n  --app-surface: var(--color-parchment-100);\n  --app-text: var(--color-text-primary);\n  --app-hint: var(--color-text-tertiary);\n  --app-link: var(--color-fire-600);\n  --app-button: var(--color-fire-600);\n  --app-button-text: var(--color-parchment-100);\n  --app-danger: var(--color-danger-500);\n  --app-separator: var(--color-wood-700);\n  --app-success: var(--color-success-500);\n  --app-warning: var(--color-warning-500);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100dvh;\n  min-height: 100dvh;\n  max-height: 100dvh;\n  /* The shell scrolls inside .ttbShellMain; keep the WebView from rubber-banding the whole page */\n  overscroll-behavior: none;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  color: var(--color-text-primary-light);\n  background-color: #2d1f10;\n\n  background-image:\n    /* Vignette — darker edges for depth */\n    radial-gradient(\n      ellipse at 50% 50%,\n      transparent 40%,\n      rgba(10, 6, 2, 0.35) 100%\n    ),\n    /* Knot 1 — dark oval spot */\n    radial-gradient(\n      ellipse 18px 28px at 15% 25%,\n      rgba(30, 18, 8, 0.6) 0%,\n      rgba(45, 28, 12, 0.3) 40%,\n      transparent 70%\n    ),\n    /* Knot 2 */\n    radial-gradient(\n      ellipse 14px 22px at 78% 62%,\n      rgba(28, 16, 6, 0.5) 0%,\n      rgba(42, 25, 10, 0.25) 45%,\n      transparent 70%\n    ),\n    /* Knot 3 */\n    radial-gradient(\n      ellipse 12px 18px at 42% 85%,\n      rgba(32, 20, 8, 0.45) 0%,\n      rgba(48, 30, 14, 0.2) 50%,\n      transparent 70%\n    ),\n    /* Grain — fine horizontal wood fibers */\n    repeating-linear-gradient(\n      180deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(90, 67, 40, 0.08) 1px,\n      rgba(90, 67, 40, 0.08) 2px,\n      transparent 2px,\n      transparent 4px\n    ),\n    /* Grain variation — slightly thicker fibers at intervals */\n    repeating-linear-gradient(\n      179deg,\n      transparent 0px,\n      transparent 11px,\n      rgba(74, 53, 32, 0.12) 11px,\n      rgba(80, 58, 35, 0.14) 13px,\n      transparent 13px,\n      transparent 29px\n    ),\n    /* Grain wave — angled lines for organic feel */\n    repeating-linear-gradient(\n      182deg,\n      transparent 0px,\n      transparent 19px,\n      rgba(65, 45, 25, 0.10) 19px,\n      rgba(70, 48, 28, 0.12) 20px,\n      transparent 20px,\n      transparent 47px\n    ),\n    /* Wide plank bands — subtle tonal shifts */\n    repeating-linear-gradient(\n      180deg,\n      rgba(74, 53, 32, 0.15) 0px,\n      rgba(58, 40, 22, 0.20) 120px,\n      rgba(74, 53, 32, 0.10) 240px,\n      rgba(65, 45, 25, 0.18) 360px\n    ),\n    /* Vertical grain variation — faint, for realism */\n    repeating-linear-gradient(\n      92deg,\n      transparent 0px,\n      rgba(80, 58, 35, 0.06) 1px,\n      transparent 3px,\n      transparent 60px,\n      rgba(70, 48, 28, 0.04) 61px,\n      transparent 63px\n    ),\n    /* Base warm gradient */\n    linear-gradient(\n      180deg,\n      #5a4328 0%,\n      #4d3820 20%,\n      #44301a 45%,\n      #3a2714 70%,\n      #2d1f10 100%\n    );\n\n  background-attachment: fixed;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  color: var(--color-fire-600);\n  text-decoration: none;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\na:hover {\n  color: var(--color-fire-500);\n  text-decoration: underline;\n}\n\nbutton {\n  font: inherit;\n  cursor: pointer;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Headings */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--font-heading);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.02em;\n  margin: 0;\n  color: var(--color-fire-600);\n}\n\nh1 {\n  font-size: var(--font-size-h1);\n  line-height: var(--line-height-h1);\n}\n\nh2 {\n  font-size: var(--font-size-h2);\n  line-height: var(--line-height-h2);\n}\n\nh3 {\n  font-size: var(--font-size-h3);\n  line-height: var(--line-height-h3);\n}\n\n/* ---------- Layout utilities ---------- */\n\n.ttbPage {\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 16px;\n  min-height: 100%;\n}\n\n@media (min-width: 768px) {\n  .ttbPage {\n    padding: 24px;\n  }\n}\n\n.ttbPageTitle {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 900;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.ttbRowBetween {\n  justify-content: space-between;\n}\n\n.ttbStackSm {\n  display: grid;\n  gap: 8px;\n}\n\n.ttbStackMd {\n  display: grid;\n}\n.ttbMb12 {\n  margin-bottom: 12px;\n}\n\n.ttbDayTitle {\n  font-size: 16px;\n  font-weight: 800;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* ---------- Icon/compact controls ---------- */\n\n.ttbIconButton {\n  height: 36px;\n  min-width: 36px;\n  border-radius: 10px;\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n  font-size: 16px;\n  font-weight: 900;\n}\n\n.ttbButtonOutlineSm {\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 10px;\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.ttbButtonOutlineSm:disabled {\n  opacity: 0.5;\n}\n\n.ttbButtonOutlineWide {\n  width: 100%;\n  border-radius: 12px;\n  font-weight: 900;\n}\n\n.ttbAvatarSm {\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  object-fit: cover;\n}\n\n/* ---------- Event card ---------- */\n\n/* Event card slots container */\n.ttbEventSlots {\n  display: grid;\n  gap: var(--space-2);\n  margin-top: var(--space-2);\n}\n\n.ttbShell {\n  min-height: 100dvh;\n  height: 100dvh;\n  display: grid;\n}\n\n.ttbShellWithNav {\n  grid-template-rows: 1fr auto;\n}\n\n.ttbShellNoNav {\n  grid-template-rows: 1fr;\n}\n\n.ttbShellMain {\n  overflow: auto;\n  min-height: 0;\n  /* At the end of the list do not hand the gesture to the page (it would drag the bottom nav) */\n  overscroll-behavior-y: contain;\n}\n\n/* ---------- Bottom navigation ---------- */\n\n.ttbBottomNav {\n  border-top: 2px solid var(--color-wood-700);\n  padding-top: var(--space-2);\n  padding-bottom: calc(var(--space-2) + var(--safe-bottom));\n  background: var(--color-wood-900);\n  box-shadow: var(--shadow-nav);\n}\n\n.ttbBottomNavDisabled {\n  opacity: 0.6;\n}\n\n.ttbBottomNavGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\n  gap: var(--space-1);\n  padding: 0 var(--space-2);\n}\n\n.ttbBottomNavLink {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-1);\n  height: 56px;\n  border-radius: var(--radius-md);\n  color: var(--color-text-secondary-light);\n  text-decoration: none;\n  font-size: var(--font-size-caption);\n  font-weight: var(--font-weight-semibold);\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\n.ttbBottomNavLink:hover {\n  background: var(--color-wood-800);\n}\n\n.ttbBottomNavLinkActive {\n  color: var(--color-fire-600);\n  background: var(--color-wood-800);\n}\n\n.ttbBottomNavLinkDisabled {\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n.ttbBottomNavIcon {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.ttbBottomNavLabel {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.ttbBottomNavBadge {\n  position: absolute;\n  top: -6px;\n  right: -14px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--app-danger);\n  color: var(--app-button-text);\n  font-size: 11px;\n  font-weight: 900;\n  line-height: 18px;\n  text-align: center;\n}\n\n/* Цветовые варианты бейджей */\n.ttbBottomNavBadge--success {\n  background: var(--color-success-500);\n  color: #fff;\n}\n\n.ttbBottomNavBadge--warning {\n  background: var(--color-warning-500);\n  color: #1a1a1a;\n}\n\n/* Группа из двух бейджей */\n.ttbBottomNavBadgeGroup {\n    position: static;\n  display: flex;\n  position: absolute;\n  justify-content: space-between;\n  top: 16px;\n  right: -12px;\n  display: flex;\n  gap: 15px;\n  /* margin: 5px; */\n\n}\n\n.ttbBottomNavBadgeGroup .ttbBottomNavBadge {\n  position: static;\n}\n\n.ttbBottomNavBadge {  \n   flex: auto;\n}\n\n.ttbButtonOutlineHeader {\n  min-height: 40px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n  font-weight: 700;\n}\n\n.ttbButtonOutlineHeader:disabled {\n  opacity: 0.5;\n}\n\n.ttbPageContent {\n  margin-top: 16px;\n}\n\n.ttbStack {\n  display: grid;\n  gap: 12px;\n}\n\n.ttbStackLg {\n  display: grid;\n  gap: 16px;\n}\n\n.ttbRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ttbRowWrap {\n  flex-wrap: wrap;\n}\n\n.ttbGrow {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.ttbCenterText {\n  text-align: center;\n}\n\n.ttbHint {\n  color: var(--app-hint);\n}\n\n.ttbDivider {\n  height: 1px;\n  background: var(--app-separator);\n}\n\n/* ---------- Desktop shell: sidebar instead of bottom nav (>=1024px) ---------- */\n\n@media (min-width: 1024px) {\n  .ttbShellWithNav {\n    grid-template-columns: var(--sidebar-width) minmax(0, 1fr);\n    grid-template-rows: 1fr;\n  }\n\n  .ttbShellWithNav > .ttbShellMain {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  .ttbShellWithNav > .ttbBottomNav {\n    grid-column: 1;\n    grid-row: 1;\n    border-top: none;\n    border-right: 2px solid var(--color-wood-700);\n    padding: var(--space-5) var(--space-3);\n    box-shadow: var(--shadow-nav);\n    overflow-y: auto;\n  }\n\n  .ttbBottomNavGrid {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2);\n    padding: 0;\n  }\n\n  .ttbBottomNavLink {\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: var(--space-3);\n    height: 48px;\n    padding: 0 var(--space-4);\n    font-size: var(--font-size-body);\n  }\n\n  .ttbBottomNavIcon {\n    font-size: 22px;\n  }\n\n  .ttbPage {\n    max-width: var(--content-max);\n    padding: var(--space-6) var(--space-7);\n  }\n}\n\n/* ---------- Buttons ---------- */\n\n.ttbButton {\n  font: inherit;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  border: none;\n  padding: 0;\n  background: transparent;\n}\n\n.ttbButton:disabled {\n  cursor: not-allowed;\n}\n\n.ttbButtonPrimary {\n  width: 100%;\n  height: 52px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-wood-700);\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  font-family: var(--font-body);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-body);\n  padding: var(--space-3) var(--space-5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-button);\n  cursor: pointer;\n  transition: all var(--transition-fast) var(--transition-timing);\n}\n\n.ttbButtonPrimary:hover:not(:disabled) {\n  background: var(--color-fire-500);\n  transform: translateY(-1px);\n}\n\n.ttbButtonPrimary:active:not(:disabled) {\n  background: var(--color-fire-700);\n  transform: translateY(0);\n}\n\n.ttbButtonPrimary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ttbButtonOutline {\n  height: 44px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n  font-weight: 700;\n}\n\n.ttbButtonOutline:disabled {\n  opacity: 0.5;\n}\n\n.ttbButtonOutlineCompact {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-weight: 800;\n}\n\n/* ---------- UI primitives ---------- */\n\n.ttbCard {\n  background: var(--color-parchment-100);\n  border-radius: var(--radius-xl);\n  padding: var(--space-4);\n  border: 3px solid var(--color-wood-700);\n  box-shadow: var(--shadow-card);\n  transition: all var(--transition-normal) var(--transition-timing);\n}\n\n.ttbCard:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-card-hover);\n}\n\n.ttbCardScrollable {\n  max-height: 240px;\n  overflow: auto;\n}\n\n/* ---------- Bottom sheet ---------- */\n\n.ttbBottomSheetRoot {\n  position: fixed;\n  inset: 0;\n  display: grid;\n  grid-template-rows: 1fr auto;\n  z-index: 50;\n}\n\n.ttbBottomSheetOverlay {\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.ttbBottomSheetPanel {\n  background: var(--app-surface);\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  border-top: 1px solid var(--app-separator);\n  padding: 16px;\n  padding-bottom: calc(16px + var(--safe-bottom));\n  max-width: 640px;\n  margin: 0 auto;\n  width: 100%;\n  max-height: 85vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n  .ttbBottomSheetRoot {\n    grid-template-rows: 1fr;\n    place-items: center;\n  }\n\n  .ttbBottomSheetOverlay,\n  .ttbBottomSheetPanel {\n    grid-area: 1 / 1;\n  }\n\n  .ttbBottomSheetOverlay {\n    width: 100%;\n    height: 100%;\n  }\n\n  .ttbBottomSheetPanel {\n    border-radius: 16px;\n    border: 1px solid var(--app-separator);\n    padding-bottom: 16px;\n    max-width: 560px;\n    max-height: 80vh;\n    position: relative;\n  }\n}\n\n.ttbBottomSheetHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ttbBottomSheetTitle {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.ttbBottomSheetClose {\n  height: 40px;\n  min-width: 40px;\n  border-radius: 10px;\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n  font-weight: 700;\n}\n\n.ttbBottomSheetBody {\n  margin-top: 12px;\n}\n\n/* ---------- Confirm sheet ---------- */\n\n.ttbConfirmMessage {\n  color: var(--app-text);\n  font-size: 14px;\n  line-height: 1.35;\n}\n\n.ttbConfirmActions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.ttbConfirmButton {\n  height: 48px;\n  border-radius: 10px;\n  font-weight: 700;\n}\n\n.ttbConfirmCancel {\n  border: 1px solid var(--app-separator);\n  background: transparent;\n  color: var(--app-text);\n}\n\n.ttbConfirmConfirm {\n  border: none;\n  background: var(--app-button);\n  color: var(--app-button-text);\n}\n\n.ttbConfirmConfirmDestructive {\n  background: var(--app-danger);\n}\n\n/* ---------- Badge ---------- */\n\n.ttbBadge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 10px;\n  border-radius: 999px;\n  border: 1px solid currentColor;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  white-space: nowrap;\n}\n\n.ttbBadgeOpen {\n  color: var(--app-success);\n}\n\n.ttbBadgePrivate {\n  color: var(--app-hint);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
